import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { useBiClickLogger } from '../hooks/useBiClickLogger';
const BiSpan = (_param)=>{
    var { biData, innerRef, stopPropagation } = _param, props = _object_without_properties(_param, [
        "biData",
        "innerRef",
        "stopPropagation"
    ]);
    const { setTrackingRef } = useBiClickLogger(biData, stopPropagation);
    return /*#__PURE__*/ React.createElement("span", _object_spread_props(_object_spread({}, props), {
        ref: (node)=>{
            setTrackingRef(node);
            innerRef && innerRef(node);
        }
    }));
};
BiSpan.displayName = 'BiSpan';
export default BiSpan;

//# sourceMappingURL=BiSpan.js.map